import { viewport } from '../../../utils/viewport';

class ChartHbarNew {
  constructor(el) {
    this.el = el;
    this.fills = el.querySelectorAll('.chart-hbar-new__item-fill');

    viewport.observe(this.el, () => {
      if (!this.chart) {
        this.init();
      }
    });
  }

  init() {
    this.fills.forEach((fill) => {
      const value = Math.min(+fill.dataset.value, 100); // Cap at 100%
      fill.style.width = value + '%';
    });
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.chart-hbar-new').forEach((el) => new ChartHbarNew(el));

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview', ($block, attributes) => {
    $block.find('.chart-hbar-new').each((i, el) => new ChartHbarNew(el, attributes));
  });
}